import requestInstance from '../../utils/instance-utils';

export const getAppConfigs = () => requestInstance.get('app-configs');
